var _style, _defs, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgImage2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 395 233",
    style: {
      enableBackground: "new 0 0 395 233"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000083787158709960219320000012878645448737974186_);}\n\t.st1{display:none;fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-opacity:0.1;}\n\t.st2{fill:url(#SVGID_00000175286741883494231440000005269536298772129173_);}\n\t.st3{fill:#C6C6C6;}\n\t.st4{opacity:0.5;}\n\t.st5{fill:url(#SVGID_00000127733579268717384060000005269517378316478648_);}\n\t.st6{fill:none;stroke:#FFFFFF;stroke-width:0.676;stroke-opacity:0.1;}\n\t.st7{fill:none;stroke:#D8D5D1;stroke-width:1.051;stroke-linecap:round;stroke-linejoin:round;}\n\t.st8{fill:url(#SVGID_00000118368943510997909660000010804674685028110514_);}\n\t.st9{fill:url(#SVGID_00000040533419688970750750000007991543440919375536_);}\n\t.st10{fill:url(#SVGID_00000080922349251167892570000013580220877131739821_);}\n\t.st11{fill:url(#SVGID_00000061467363294148130990000017038354577228614284_);}\n\t.st12{fill:#D8D5D1;}\n\t.st13{fill:url(#SVGID_00000098925637812217335490000013431768040124896407_);}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M16.3,0h362c8.8,0,16,7.2,16,16v201c0,8.8-7.2,16-16,16h-362c-8.8,0-16-7.2-16-16V16C0.3,7.2,7.5,0,16.3,0z "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000147198151612431129440000001545506870446078141_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000147198151612431129440000001545506870446078141_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M195.5,60.8L195.5,60.8c30.2,0,54.8,24.5,54.8,54.8l0,0c0,30.2-24.5,54.8-54.8,54.8l0,0 c-30.2,0-54.8-24.5-54.8-54.8l0,0C140.8,85.3,165.3,60.8,195.5,60.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047046237764849163250000017631261375560453282_",
    gradientUnits: "userSpaceOnUse",
    x1: 268.3744,
    y1: 132.6055,
    x2: 119.7517,
    y2: 93.1464
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010208"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#161616"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047046237764849163250000017631261375560453282_)"
    },
    d: "M220.9,169.8h-53.6 c-16.6,0-30.1-13.5-30.1-30.1V86.1c0-16.6,13.5-30.1,30.1-30.1h53.6c16.6,0,30.1,13.5,30.1,30.1v53.6 C250.9,156.3,237.5,169.8,220.9,169.8z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1863",
    className: "st3",
    d: "M192.3,83.5c-1,0.5-1.4,1.3-1.7,1.9c-0.3,0.6-0.5,1.2-1,1.7c-0.5,0.6-1.3,1.2-3,1.9 c-1.7,0.7-2.7,0.8-3.5,0.7c-0.8-0.1-1.3-0.3-1.9-0.6c-0.8-0.3-1.6-0.5-2.6-0.2c-1,0.3-2,1-3.4,2.4c-1.4,1.4-2.2,2.4-2.5,3.4 c-0.4,1.1-0.1,1.9,0.2,2.6c0.3,0.7,0.5,1.1,0.5,1.9s-0.1,1.8-0.8,3.5c-0.7,1.7-1.4,2.5-2,3c-0.6,0.5-1.1,0.7-1.8,1 s-1.4,0.7-1.9,1.8c-0.5,1-0.7,2.3-0.7,4.3c0,0,0,0,0,0c0,0,0,0,0,0c0,2.1,0.2,3.4,0.7,4.3c0.5,1,1.3,1.5,1.9,1.8 c0.7,0.3,1.2,0.5,1.8,1c0.6,0.5,1.3,1.3,2,3c0.7,1.7,0.8,2.7,0.8,3.5c-0.1,0.8-0.3,1.2-0.5,1.9c-0.3,0.7-0.5,1.5-0.2,2.6 c0.3,1,1.1,2,2.5,3.4c1.4,1.4,2.4,2.1,3.4,2.4c1,0.3,1.8,0.1,2.6-0.2c0.6-0.3,1.1-0.5,1.9-0.6c0.8-0.1,1.8,0,3.5,0.7 c1.7,0.7,2.5,1.3,3,1.9c0.5,0.6,0.7,1.1,1,1.7c0.3,0.6,0.7,1.4,1.7,1.9c0.9,0.4,2.1,0.6,3.9,0.6c1.8,0,3-0.2,3.9-0.6 c1-0.5,1.4-1.3,1.7-1.9c0.3-0.6,0.5-1.2,1-1.7c0.5-0.6,1.3-1.2,3-1.9c1.7-0.7,2.7-0.8,3.5-0.7c0.8,0.1,1.3,0.3,1.9,0.6 c0.8,0.3,1.6,0.5,2.6,0.2c1-0.3,2-1,3.4-2.4c1.4-1.4,2.2-2.4,2.5-3.4c0.4-1.1,0.1-1.9-0.2-2.6c-0.3-0.7-0.5-1.1-0.5-1.9 c-0.1-0.8,0.1-1.8,0.8-3.5c0.7-1.7,1.4-2.5,2-3s1.1-0.7,1.8-1c0.7-0.3,1.4-0.7,1.9-1.8c0.5-1,0.7-2.3,0.7-4.3 c0-2.1-0.2-3.4-0.7-4.3c-0.5-1-1.3-1.5-1.9-1.8c-0.7-0.3-1.2-0.5-1.8-1c-0.6-0.5-1.3-1.3-2-3c-0.7-1.7-0.8-2.7-0.8-3.5 c0.1-0.8,0.3-1.2,0.5-1.9c0.3-0.7,0.5-1.5,0.2-2.6c-0.3-1-1.1-2-2.5-3.4c-1.4-1.4-2.4-2.1-3.4-2.4c-1-0.3-1.8-0.1-2.6,0.2 c-0.6,0.3-1.1,0.5-1.9,0.6c-0.8,0.1-1.8,0-3.5-0.7c-1.7-0.7-2.5-1.3-3-1.9c-0.5-0.6-0.7-1.1-1-1.7c-0.3-0.6-0.7-1.4-1.7-1.9 c-0.9-0.4-2.1-0.6-3.9-0.6C194.4,82.8,193.2,83,192.3,83.5z M196.3,84.8c1.7,0,2.6,0.2,3,0.4c0.4,0.2,0.5,0.4,0.8,0.9 c0.2,0.5,0.5,1.4,1.3,2.2c0.7,0.9,1.9,1.7,3.8,2.5c1.9,0.8,3.3,1,4.4,0.9c1.1-0.1,1.9-0.5,2.5-0.7c0.4-0.2,0.7-0.3,1.2-0.1 c0.5,0.1,1.3,0.7,2.6,2c1.3,1.3,1.9,2.1,2,2.6c0.2,0.5,0,0.9-0.1,1.2c-0.2,0.5-0.6,1.4-0.7,2.5s0.1,2.5,0.9,4.4 c0.8,1.9,1.7,3,2.5,3.7c0.9,0.7,1.7,1,2.2,1.3c0.5,0.2,0.8,0.4,1,0.8c0.3,0.5,0.4,1.5,0.5,2.5l0,1c0,0,0,1,0,1 c0,1-0.2,2-0.5,2.5c-0.2,0.4-0.4,0.6-1,0.8c-0.5,0.2-1.4,0.5-2.2,1.3c-0.9,0.7-1.7,1.9-2.5,3.7c-0.8,1.9-1,3.3-0.9,4.4 c0.1,1.1,0.5,1.9,0.7,2.5c0.1,0.4,0.3,0.7,0.1,1.2c-0.2,0.5-0.7,1.3-2,2.6c-1.3,1.3-2.2,1.8-2.6,2c-0.5,0.1-0.8,0-1.2-0.1 c-0.5-0.2-1.4-0.6-2.5-0.7c-1.1-0.1-2.5,0.1-4.4,0.9c-1.9,0.8-3,1.6-3.8,2.5c-0.7,0.9-1.1,1.7-1.3,2.2c-0.2,0.5-0.4,0.8-0.8,0.9 c-0.4,0.2-1.3,0.4-3,0.4c-1.7,0-2.6-0.2-3-0.4c-0.4-0.2-0.5-0.4-0.8-0.9c-0.2-0.5-0.5-1.4-1.3-2.2c-0.7-0.9-1.9-1.7-3.8-2.5 c-1.9-0.8-3.3-1-4.4-0.9c-1.1,0.1-1.9,0.5-2.5,0.7c-0.4,0.2-0.7,0.3-1.2,0.1c-0.5-0.1-1.3-0.7-2.6-2c-1.3-1.3-1.9-2.1-2-2.6 c-0.2-0.5,0-0.9,0.1-1.2c0.2-0.5,0.6-1.4,0.7-2.5c0.1-1.1-0.1-2.5-0.9-4.4c-0.8-1.9-1.7-3-2.5-3.7c-0.9-0.7-1.7-1-2.2-1.3 c-0.5-0.2-0.8-0.4-1-0.8c-0.3-0.5-0.4-1.5-0.5-2.5l0-1l0-1c0-1,0.2-2,0.5-2.5c0.2-0.4,0.4-0.6,1-0.8c0.5-0.2,1.4-0.5,2.2-1.3 c0.9-0.7,1.7-1.9,2.5-3.7c0.8-1.9,1-3.3,0.9-4.4c-0.1-1.1-0.5-1.9-0.7-2.5c-0.1-0.4-0.3-0.7-0.1-1.2c0.2-0.5,0.7-1.3,2-2.6 c1.3-1.3,2.2-1.8,2.6-2c0.5-0.1,0.8,0,1.2,0.1c0.5,0.2,1.4,0.6,2.5,0.7c1.1,0.1,2.5-0.1,4.4-0.9c1.9-0.8,3-1.6,3.8-2.5 c0.7-0.9,1.1-1.7,1.3-2.2c0.2-0.5,0.4-0.8,0.8-0.9C193.7,85,194.6,84.8,196.3,84.8z M196.3,92.8c-11.1,0-20,9-20,20 s8.9,20,20,20c11,0,20-9,20-20S207.3,92.8,196.3,92.8z M196.3,94.8c7.5,0,13.9,4.5,16.6,11c-0.9,0-1.8,0-2.7,0 c-0.5,0.1-0.9,0.5-0.9,1v1c-2.8,0-5.8-1.8-10-2c-0.5,0-1,0-1.5,0c-1.5,0-2.8,0.4-4.3,1.7c-0.3-0.1-0.4-0.1-0.9-0.2 c-0.4-0.1-1.6-0.4-2.4-0.4c-1.2,0-2.7,0.3-4.2,0.5c-1,0.2-2,0.3-2.8,0.4v-0.9c0-0.6-0.5-1-1-1h-2.6 C182.4,99.4,188.8,94.8,196.3,94.8z M196.3,97.8c-0.6,0-1,0.4-1,1v2c0,0.7,0.5,1,1,1c0.5,0,1-0.3,1-1v-2 C197.3,98.3,196.8,97.8,196.3,97.8z M190.1,102.1l1.4,1.4c1,0.9,2.3-0.5,1.4-1.4l-1.4-1.4c-0.2-0.2-0.4-0.3-0.7-0.3 C189.9,100.4,189.5,101.5,190.1,102.1z M201,100.7l-1.4,1.4c-0.9,0.9,0.4,2.3,1.4,1.4l1.4-1.4c0.6-0.6,0.2-1.7-0.7-1.7 C201.4,100.4,201.2,100.5,201,100.7z M199.2,107.8c3.7,0.2,6.9,2,10,2v7c-2.2,0-3.5,0.2-6.6,1.7l-4.6-5.3 c0.5-0.9-0.6-1.9-1.4-1.3c-1.4,0.9-2.9,1.8-4.4,2.6c-0.6,0.3-1.3,0.5-1.7,0c-0.4-0.4-0.5-1.2,0-1.6l3.8-3.7 c1.3-1.3,2.5-1.5,3.5-1.5C198.3,107.8,198.7,107.8,199.2,107.8L199.2,107.8z M191.8,109.1l-2.6,2.5c-1.2,1.2-1.3,3.2-0.1,4.5 c1.3,1.3,3.1,1.1,4.4,0.2c1.1-0.6,2.1-1.2,3-1.7l4.4,5.1c-1.2,0.7-2.4,1.5-3.5,2.1c-1.4,0.7-2.4,1.2-3.2,1.2 c-0.4,0-1.1-0.3-2-0.8c-0.8-0.5-1.8-1.3-2.7-2c-1.9-1.5-4.2-3.2-6.3-3.2v-7.1c1-0.1,2.1-0.3,3.2-0.5c1.5-0.2,3-0.5,3.8-0.5 C190.5,108.8,190.9,108.9,191.8,109.1z M183.3,118.8c1.3,0,3.1,1.3,5.1,2.8c1,0.7,1.9,1.5,2.9,2.1c1,0.6,2,1.1,3,1.1 c1.2,0,2.7-0.6,4.1-1.4c1.4-0.8,3-1.8,4.5-2.7c3.1-1.6,4.2-1.9,6.3-1.9v1c0,0.6,0.4,1,1,1h2.1c-3,5.9-9.1,10-16.1,10 s-13.1-4.1-16.1-10h2.1c0.6,0,1-0.4,1-1L183.3,118.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060010282924345923230000015013988310297921447_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.1,
    y1: 108.6296,
    x2: -0.008004388,
    y2: 92.9366,
    gradientTransform: "matrix(1 0 0 -1 0 234)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010208"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#161616"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060010282924345923230000015013988310297921447_)"
    },
    d: "M29.5,108.2L29.5,108.2 c13.8,0,25,11.2,25,25l0,0c0,13.8-11.2,25-25,25l0,0c-13.8,0-25-11.2-25-25l0,0C4.5,119.4,15.7,108.2,29.5,108.2z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M29.5,108.6L29.5,108.6c13.6,0,24.7,11,24.7,24.7l0,0c0,13.6-11,24.7-24.7,24.7l0,0 c-13.6,0-24.7-11-24.7-24.7l0,0C4.9,119.6,15.9,108.6,29.5,108.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M19.3,122.9l2.1,2.1 M40.3,122.9l-2.1,2.1 M40.3,144l-2.1-2.1 M19.3,144l2.1-2.1 M19.3,137.6h1.6  M25.6,122.9v1.6 M40.3,129.2h-1.6 M34,144v-1.6 M36.1,137.6h3.7 M34,122.9v4.2 M19.3,129.2h4.2 M25.6,144v-4.2 M29.2,128.8 l-4.1,4.1c-0.2,0.2-0.3,0.3-0.4,0.4c0,0.1,0,0.2,0,0.3c0,0.1,0.1,0.2,0.4,0.4l4.1,4.1c0.2,0.2,0.3,0.3,0.4,0.4c0.1,0,0.2,0,0.3,0 c0.1,0,0.2-0.1,0.4-0.4l4.1-4.1c0.2-0.2,0.3-0.3,0.4-0.4c0-0.1,0-0.2,0-0.3c0-0.1-0.1-0.2-0.4-0.4l-4.1-4.1 c-0.2-0.2-0.3-0.3-0.4-0.4c-0.1,0-0.2,0-0.3,0C29.5,128.5,29.4,128.6,29.2,128.8L29.2,128.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000138543547372674473560000016062267060109491386_",
    gradientUnits: "userSpaceOnUse",
    x1: 380.3279,
    y1: 150.3466,
    x2: 321.2198,
    y2: 134.6535,
    gradientTransform: "matrix(1 0 0 -1 0 234)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010208"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#161616"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000138543547372674473560000016062267060109491386_)"
    },
    d: "M350.8,66.5L350.8,66.5 c13.8,0,25,11.2,25,25l0,0c0,13.8-11.2,25-25,25l0,0c-13.8,0-25-11.2-25-25l0,0C325.8,77.7,337,66.5,350.8,66.5z"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M350.8,66.8L350.8,66.8c13.6,0,24.7,11,24.7,24.7l0,0c0,13.6-11,24.7-24.7,24.7l0,0 c-13.6,0-24.7-11-24.7-24.7l0,0C326.1,77.9,337.2,66.8,350.8,66.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M355.2,98l2.1,2.1l4.2-4.2 M361.5,89.6h-21 M361.5,91.7v-4c0-1.2,0-1.8-0.2-2.2c-0.2-0.4-0.5-0.7-0.9-0.9 c-0.5-0.2-1-0.2-2.2-0.2h-14.3c-1.2,0-1.8,0-2.2,0.2c-0.4,0.2-0.7,0.5-0.9,0.9c-0.2,0.5-0.2,1-0.2,2.2v8c0,1.2,0,1.8,0.2,2.2 c0.2,0.4,0.5,0.7,0.9,0.9c0.5,0.2,1,0.2,2.2,0.2h7.1"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171679604220655246520000005553941067739811481_",
    gradientUnits: "userSpaceOnUse",
    x1: 168.3733,
    y1: 37.7292,
    x2: 109.2653,
    y2: 22.0362,
    gradientTransform: "matrix(1 0 0 -1 0 234)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010208"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#161616"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000171679604220655246520000005553941067739811481_)"
    },
    d: "M138.8,179.1L138.8,179.1 c13.8,0,25,11.2,25,25l0,0c0,13.8-11.2,25-25,25l0,0c-13.8,0-25-11.2-25-25l0,0C113.8,190.3,125,179.1,138.8,179.1z"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M138.8,179.5L138.8,179.5c13.6,0,24.7,11,24.7,24.7l0,0c0,13.6-11,24.7-24.7,24.7h0 c-13.6,0-24.7-11-24.7-24.7l0,0C114.2,190.5,125.2,179.5,138.8,179.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M131.7,214.9h14.7 M129.1,200.1h20 M136.9,193.8l-2.1,6.3l4.2,11l4.2-11l-2.1-6.3 M139.7,211l9.4-10.3 c0.2-0.2,0.3-0.3,0.3-0.4c0-0.1,0-0.2,0-0.3c0-0.1-0.1-0.2-0.3-0.4l-4.5-5.4c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1,0-0.1-0.1-0.2-0.1 c-0.1,0-0.1,0-0.3,0h-9.7c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0-0.2,0.1c-0.1,0-0.1,0.1-0.2,0.2l-4.5,5.4c-0.2,0.2-0.2,0.3-0.3,0.4 c0,0.1,0,0.2,0,0.3c0,0.1,0.1,0.2,0.3,0.4l9.4,10.3c0.2,0.2,0.3,0.4,0.5,0.4c0.1,0,0.2,0,0.3,0 C139.3,211.4,139.5,211.3,139.7,211L139.7,211z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008114538997894293980000002175367913300245383_",
    gradientUnits: "userSpaceOnUse",
    x1: 375.2053,
    y1: 38.7315,
    x2: 316.0973,
    y2: 23.0386,
    gradientTransform: "matrix(1 0 0 -1 0 234)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010208"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#161616"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008114538997894293980000002175367913300245383_)"
    },
    d: "M345.7,178.1L345.7,178.1 c13.8,0,25,11.2,25,25l0,0c0,13.8-11.2,25-25,25l0,0c-13.8,0-25-11.2-25-25l0,0C320.7,189.3,331.8,178.1,345.7,178.1z"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M345.7,178.5L345.7,178.5c13.6,0,24.7,11,24.7,24.7l0,0c0,13.6-11,24.7-24.7,24.7h0 c-13.6,0-24.7-11-24.7-24.7l0,0C321,189.5,332,178.5,345.7,178.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M339.1,193.5l-1.6,2.2c-0.3,0.4-0.5,0.6-0.5,0.8c0,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.4,0.1,1,0.1h15.6 c0.5,0,0.8,0,1-0.1c0.1-0.1,0.2-0.2,0.2-0.4c0-0.2-0.2-0.4-0.5-0.8l-1.6-2.2 M339.1,193.5c0.2-0.2,0.3-0.4,0.4-0.5 c0.1-0.1,0.2-0.1,0.3-0.2c0.1,0,0.3,0,0.6,0h10.9c0.3,0,0.5,0,0.6,0c0.1,0,0.2,0.1,0.3,0.2c0.1,0.1,0.2,0.2,0.4,0.5 M339.1,193.5 l-2,2.6c-0.2,0.3-0.4,0.5-0.5,0.7c-0.1,0.2-0.1,0.3-0.2,0.5c0,0.2,0,0.4,0,0.8v12.3c0,1.2,0,1.8,0.2,2.2c0.2,0.4,0.5,0.7,0.9,0.9 c0.4,0.2,1,0.2,2.2,0.2H352c1.2,0,1.8,0,2.2-0.2c0.4-0.2,0.7-0.5,0.9-0.9c0.2-0.4,0.2-1,0.2-2.2v-12.3c0-0.4,0-0.6,0-0.8 c0-0.2-0.1-0.3-0.2-0.5c-0.1-0.2-0.2-0.3-0.5-0.7l-2-2.6 M350.1,201.2c0,2.3-1.9,4.2-4.2,4.2c0,0,0,0,0,0c-2.3,0-4.2-1.9-4.2-4.2 "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082356818298011417910000012276959110465096595_",
    gradientUnits: "userSpaceOnUse",
    x1: 77.2673,
    y1: 206.8473,
    x2: 18.1593,
    y2: 191.1543,
    gradientTransform: "matrix(1 0 0 -1 0 234)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010208"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#161616"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000082356818298011417910000012276959110465096595_)"
    },
    d: "M47.7,10L47.7,10c13.8,0,25,11.2,25,25 l0,0c0,13.8-11.2,25-25,25l0,0c-13.8,0-25-11.2-25-25l0,0C22.7,21.2,33.9,10,47.7,10z"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M47.7,10.3L47.7,10.3c13.6,0,24.7,11,24.7,24.7l0,0c0,13.6-11,24.7-24.7,24.7l0,0c-13.6,0-24.7-11-24.7-24.7 l0,0C23.1,21.4,34.1,10.3,47.7,10.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M47.7,26.1c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0v-3.1c0-0.2-0.1-0.3-0.3-0.3s-0.3,0.1-0.3,0.3v3.1 C47.4,26,47.5,26.1,47.7,26.1C47.7,26.1,47.7,26.1,47.7,26.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M40.4,29.5c0.1,0.1,0.3,0.1,0.4,0s0.1-0.3,0-0.4l-2.2-2.2c-0.1-0.1-0.3-0.1-0.4,0c-0.1,0.1-0.1,0.3,0,0.4 L40.4,29.5z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M37.7,35.9h-3.1c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3c0,0,0,0,0,0h3.1c0.2,0,0.3-0.1,0.3-0.3 C38,36,37.9,35.9,37.7,35.9z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M40.4,42.6l-2.2,2.2c-0.1,0.1-0.1,0.3,0,0.4s0.3,0.1,0.4,0l0,0l2.2-2.2c0.1-0.1,0.1-0.3,0-0.4 C40.8,42.5,40.6,42.5,40.4,42.6L40.4,42.6L40.4,42.6z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M54.8,29.5c0.1,0,0.2,0,0.2-0.1l2.2-2.2c0.1-0.1,0.1-0.3,0-0.4c-0.1-0.1-0.3-0.1-0.4,0L54.6,29 c-0.1,0.1-0.1,0.3,0,0.4C54.6,29.5,54.7,29.5,54.8,29.5L54.8,29.5z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M60.9,35.9h-3.1c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.1c0.2,0,0.3-0.1,0.3-0.3 C61.2,36,61,35.9,60.9,35.9C60.9,35.9,60.9,35.9,60.9,35.9z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M55,42.6c-0.1-0.1-0.3-0.1-0.4,0c-0.1,0.1-0.1,0.3,0,0.4l0,0l2.2,2.2c0.1,0.1,0.3,0.1,0.4,0 c0.1-0.1,0.1-0.3,0-0.4L55,42.6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M53.5,29.3c-1.4-1.4-3.6-2.1-6.5-2c-0.2,0-0.3,0.1-0.3,0.3v0.6h-0.8c-0.2,0-0.3,0.1-0.3,0.3l-0.2,1.8 c-0.5,0.1-1,0.3-1.5,0.6l-1.4-1.2c-0.1-0.1-0.3-0.1-0.4,0l-1.6,1.6c-0.1,0.1-0.1,0.3,0,0.4l1.2,1.4c-0.3,0.5-0.5,0.9-0.6,1.4 l-1.8,0.2c-0.2,0-0.3,0.1-0.3,0.3v2.2c0,0.2,0.1,0.3,0.3,0.3l1.8,0.2c0.1,0.5,0.3,1,0.6,1.5l-1.2,1.4c-0.1,0.1-0.1,0.3,0,0.4 l1.6,1.6c0.1,0.1,0.3,0.1,0.4,0l1.4-1.1c0.5,0.3,1,0.5,1.5,0.6l0.2,1.8c0,0.2,0.1,0.3,0.3,0.3h0.8v3.6c0,0.2,0.1,0.3,0.3,0.3 c0,0,0,0,0,0h4.3c0.2,0,0.3-0.1,0.3-0.3V45c0,0,0-0.1,0-0.1l0-3.3c0-0.3,0.2-0.6,0.5-0.8c2.2-1.5,3.4-3.6,3.4-5.9 C55.5,32.4,54.8,30.5,53.5,29.3z M46.8,39.9c-2.1-0.2-3.6-2-3.4-4c0.1-1.8,1.6-3.3,3.4-3.4V39.9z M46.2,43.6L46,42v-0.1 c0-0.1-0.1-0.3-0.2-0.3l-0.1,0c-0.6-0.1-1.1-0.4-1.6-0.7c-0.1-0.1-0.2-0.1-0.3,0L42.4,42l-1.2-1.2l1-1.3l0.1-0.1 c0.1-0.1,0.1-0.2,0-0.3c-0.3-0.5-0.5-1.1-0.7-1.6c0-0.1-0.1-0.2-0.2-0.2l-0.2,0L39.6,37v-1.7l1.6-0.2l0.2,0 c0.1,0,0.2-0.1,0.2-0.2c0.1-0.6,0.4-1.1,0.7-1.6c0.1-0.1,0.1-0.2,0-0.3l-1.1-1.4l1.2-1.2l1.3,1l0.1,0.1c0.1,0.1,0.3,0.1,0.4,0 l0,0c0.5-0.3,1.1-0.5,1.6-0.7c0.1,0,0.2-0.2,0.2-0.3l0.2-1.7h0.5v3.1c-2.4,0.2-4.2,2.2-4,4.6c0.2,2.2,1.9,3.9,4,4v3.1L46.2,43.6z  M51,47.5h-3.7v-2.1H51V47.5z M51.8,40.3c-0.5,0.3-0.7,0.8-0.7,1.3l0,3.1h-2.1v-6.6l3.8-3c0.1-0.1,0.2-0.3,0.1-0.4 c-0.1-0.1-0.3-0.2-0.4-0.1l0,0l-3.9,3.1c-0.1,0.1-0.1,0.1-0.1,0.2v6.8h-0.9V27.8h0.1c2.5,0,4.4,0.6,5.7,1.8 c1.2,1.2,1.8,2.9,1.8,5.2C54.9,37,53.8,38.9,51.8,40.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159454701294740949210000011299309317136647607_",
    gradientUnits: "userSpaceOnUse",
    x1: 246.8954,
    y1: 222.9108,
    x2: 187.7874,
    y2: 207.2179,
    gradientTransform: "matrix(1 0 0 -1 0 234)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010208"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#161616"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000159454701294740949210000011299309317136647607_)"
    },
    d: "M217.3-6.1L217.3-6.1 c13.8,0,25,11.2,25,25l0,0c0,13.8-11.2,25-25,25l0,0c-13.8,0-25-11.2-25-25l0,0C192.3,5.1,203.5-6.1,217.3-6.1z"
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M217.3-5.7L217.3-5.7c13.6,0,24.7,11,24.7,24.7l0,0c0,13.6-11,24.7-24.7,24.7l0,0c-13.6,0-24.7-11-24.7-24.7 l0,0C192.7,5.3,203.7-5.7,217.3-5.7z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M209.2,18.1l8.4,2.1l8.4-2.1 M209.2,18.1l8.4-9.5 M209.2,18.1l8.4-2.1 M226,18.1l-8.4-9.5 M226,18.1 l-8.4-2.1 M217.6,8.7V16 M210.7,22.3l6.8,7.4l6.8-7.4l-6.8,1.6L210.7,22.3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgImage2);
export default __webpack_public_path__ + "static/media/BgImage2.2815700bbd2be126d914bcdfdcb873ad.svg";
export { ForwardRef as ReactComponent };